import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";
import {ConditionsProps} from "../utils/segmentBuilder";

export const getSegmentShopClients = async (domain: string, conditions: ConditionsProps[], abortSignal?: any): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `segment/shop-clients`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        params: {
            conditions
        },
        isEncrypted: false,
        abortSignal,
    });
}